import { L1Client } from "@turnstile-portal/turnstile.js";
import type { Account, Chain, PublicClient, Transport, WalletClient } from "viem";
import { createConfig, http } from "wagmi";
import { getPublicClient, getWalletClient } from "wagmi/actions";
import { anvil, sepolia } from "wagmi/chains";
import { coinbaseWallet, metaMask } from "wagmi/connectors";

export const config = createConfig({
  chains: [anvil, sepolia],
  connectors: [
    // injected(),
    metaMask({
      dappMetadata: {
        name: "Turnstile",
        url: "https://clarified.io",
        iconUrl: "https://clarified.io/favicon.ico",
      },
    }),
    coinbaseWallet(),
    // walletConnect({ projectId: import.meta.env.VITE_WC_PROJECT_ID }),
  ],
  transports: {
    // [mainnet.id]: http(),
    [anvil.id]: http(import.meta.env.VITE_ETH_RPC_URL || "https://sandbox.ethereum.walletmesh.com/api/v1/public"),
    [sepolia.id]: http(import.meta.env.VITE_ETH_RPC_URL || "https://sepolia.ethereum.walletmesh.com/api/v1/public"),
  },
});

export type ChainId = (typeof config)["chains"][number]["id"];
export type WalletClientWithAccount = WalletClient<Transport, Chain, Account>;

declare module "wagmi" {
  interface Register {
    config: typeof config;
  }
}

export function getL1Client(walletClient: WalletClientWithAccount, publicClient: PublicClient): L1Client {
  return new L1Client(publicClient, walletClient);
}

// Test helper to override L1 client for testing
let testL1Client: L1Client | null = null;

export function setTestL1Client(client: L1Client): void {
  testL1Client = client;
}

export function clearTestL1Client(): void {
  testL1Client = null;
}

export async function getL1ClientAsync(): Promise<L1Client> {
  if (testL1Client) {
    return testL1Client;
  }
  return getL1Client(await getWalletClient(config), getPublicClient(config));
}
